import { Component, inject, input, model, output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule, NgTemplateOutlet } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ListCardComponent } from 'app/core/components/list-card/list-card.component';
import { AppSettings } from '@services/settings/app-settings.service';
import { CatalogService } from '@services/data/catalog.service';
import { BpmService } from '../../services/bpm.service';
import { Request } from '../../services/requests.service';

export interface RequestTypeFilter {
  slug: string;
  name: string;
  icon?: string;
}

@Component({
  selector: 'app-request-list',
  standalone: true,
  imports: [CommonModule, NgTemplateOutlet, FormsModule, ListCardComponent],
  templateUrl: './request-list.component.html',
  styleUrl: './request-list.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager
})
export class RequestListComponent {
  requests = input<Request[]>([]);
  isLoading = input(false);
  selectedUuid = input<string | null>(null);
  typeFilters = input<RequestTypeFilter[]>([]);

  searchQuery = model('');
  /** Filtro por processSlug; null = todos */
  activeTypeFilter = model<string | null>(null);

  selectRequest = output<Request>();

  readonly appSettings = inject(AppSettings);
  private readonly catalogService = inject(CatalogService);
  private readonly bpmService = inject(BpmService);

  private entityIndex = () =>
    new Map(this.catalogService.entities().map((e) => [String(e.code), e]));

  onSelectRequest(request: Request): void {
    this.selectRequest.emit(request);
  }

  toggleTypeFilter(slug: string): void {
    const next = this.activeTypeFilter() === slug ? null : slug;
    this.activeTypeFilter.set(next);
  }

  getEntityCampus(code: number | string): string {
    if (!code) return 'N/A';
    const entity = this.entityIndex().get(String(code));
    return entity ? `${entity.campus}` : `Entidad ${code}`;
  }

  hasObservedEvidence(request: Request): boolean {
    return !!request.needsOriginInbox || this.bpmService.hasObservedClaimDocuments(request);
  }
}
